// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-card_default__26nqb","name":"idt-card_name__javds","checkmark":"idt-card_checkmark__31hn1","icon":"idt-card_icon__rgyn8"};